import React from "react";
import { Modal, useMediaQuery } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import "../../styles/dialog-premium.css";

interface ChartDescriptionsProps {
  open: boolean;
  description: string;
  onClose: () => void;
}

const ChartDescriptions: React.FC<ChartDescriptionsProps> = ({
  open,
  description,
  onClose,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="premium-modal-root"
      BackdropProps={{ className: "premium-modal-backdrop" }}
      aria-labelledby="chart-description-title"
    >
      <div
        className={`premium-modal-panel ${isMobile ? "" : "premium-modal-panel--wide"}`}
      >
        <div className="premium-dialog-header">
          <h2 id="chart-description-title" className="premium-dialog-title">
            Job Description
          </h2>
          <button
            type="button"
            className="premium-dialog-close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseRoundedIcon sx={{ fontSize: 18 }} />
          </button>
        </div>

        <div className="premium-dialog-body premium-dialog-body--with-icon">
          <div className="premium-dialog-icon premium-dialog-icon--info">
            <DescriptionOutlinedIcon />
          </div>
          <div className="premium-dialog-content">
            <p className="premium-dialog-message">{description}</p>
          </div>
        </div>

        <div className="premium-dialog-footer">
          <button
            type="button"
            className="premium-dialog-btn premium-dialog-btn--primary"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ChartDescriptions;
